import { fromJS, Record } from 'immutable';
import {
  generateKeys,
  generateSchema,
} from '../../../../utils/helpers/model.helper';
import { ITrackingObject, TrackingObjectNamesEnum } from '../../tracking.data';

export const TRACKING_DOCUMENT_LIST_SCHEMA = Object.freeze({
  DOCUMENT_TYPE: '',
});
const RECORD = generateSchema(TRACKING_DOCUMENT_LIST_SCHEMA);
const KEYS: any = generateKeys(TRACKING_DOCUMENT_LIST_SCHEMA);

export class DocumentListTrackingObject
  extends Record(RECORD)
  implements ITrackingObject {
  static KEYS = KEYS;

  constructor(props?: any) {
    super(props && props.toMap ? props.toMap() : fromJS(props || {}));
  }

  get name() {
    return TrackingObjectNamesEnum.document_list;
  }

  get properties() {
    return this.toJS();
  }
}
